
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewVoD from './viewVoD';
import viewRelatedVods from './viewRelatedVods';

export default {
  attributeName: 'composeExperienceMulticams',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canCreateWhen: {"field":"name","values":"not-null"},
  canRemove: true,  
  emptyMessage: "You don't have any VoD in your Composed Experience Multicam. Please add one at least.",
  fields: [
    {
      attributeName: 'name',
      label: 'Vod name',
      type: FormInputTypes.TEXT_OR_RELATIONSHIP,
      helpText: 'VoDs to add to the composed experience multicam.',
      configFile: viewRelatedVods,
      default: '',
      blockInput:true,
      width: '12rem',
      popupSize:'xl',
      additionalUpdates: [{
        relationshipField:"type",
        updateField: "type"
      },
      {
        relationshipField:"hls_enable",
        updateField: "hls_enable"
      }],
      canEdit: false,
      canCreate: true,
      canRemove: true,
      rowKeys: {
        mainKey: 'name',
        foreignKey: 'vodId',
        foreignKeyName: 'VoD',
        valueToShow: 'name',
      },
    },
    {
      attributeName: 'hls_enable',
      label: 'Hls',
      relatedTo: 'name',
      type: FormInputTypes.TEXT,
      canEdit: false,
      canOrder: true,
      canCreate: true,
      width: '8rem',
      helpText: 'Type of VoD Added.',
    },
    {
      attributeName: 'type',
      label: 'Vod Type',
      relatedTo: 'name',
      type: FormInputTypes.TEXT,
      canEdit: false,
      canOrder: true,
      canCreate: true,
      width: '8rem',
      helpText: 'Type of VoD Added.',
    },
    {
      attributeName: 'cameraName',
      label: 'Camera Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,  
      canEdit: true,    
      default: 'Camera Name',
      canOrder: true,
      canCreate: true,
      delayedUpdate: 50,
      width: '8rem',
      helpText: 'Camera Name.',
      enabledWhen:{"field":"name","values":"not-null"},
    },
    {
      attributeName: 'audio',
      label: 'Select audio',
      default: false,
      type: FormInputTypes.RADIO,
      canEdit: true,
      canOrder: false,
      canCreate: true,
      width: '12rem',
      helpText: 'Select audio to be used in the composed experience multicam.',
      enabledWhen:{"field":"name","values":"not-null"},
    },
  ],
};
